module.exports = __webpack_public_path__ + "media/images/element/04-f07f2475c9c558e5f69a1491a4cbd581.svg";